export const ESCALATION_FOLLOW_UP_OUTCOME = {
  SUCCESSFUL: {
    label: "Successful",
    value: "SUCCESSFUL",
    icon: "FeatherThumbsUp",
  },
  ATTENTION_NEEDED: {
    label: "Needs Attention",
    value: "NEEDS_ATTENTION",
    icon: "FeatherAlertTriangle",
  },
  OTHER: {
    label: "Other",
    value: "OTHER",
    icon: "FeatherMoreHorizontal",
  },
};
